(function($) {
$(document).ready(function() {
var priceConnectedToCurrencies = {
productPriceEl: false,
newPriceEl: $('<span class="money">'),
init: function() {
this.productPriceEl = $('.cpb-product-price');
this.newPriceEl.text(this.productPriceEl.text()); 
this.productPriceEl.closest('.row').hide().after($('<div class="row">').append($('<div class="cpb-custom-product-price current_price">').append(this.newPriceEl)));
currencyConverter.convertCurrencies();
$('body').on('CPB_ON_OPTIONS_UPDATE', function() {
this.update();
}.bind(this));
},
update: function() {
var attributesToRemove = [];
for(var i = 0; i < this.newPriceEl[0].attributes.length; i++) {
var attr = this.newPriceEl[0].attributes[i].name;
if(attr.indexOf('data-currency') === 0) attributesToRemove.push(attr);
}
for(var i = 0; i < attributesToRemove.length; i++) {
this.newPriceEl.removeAttr(attributesToRemove[i])
}
this.newPriceEl.text(this.productPriceEl.text());
currencyConverter.convertCurrencies();
}
}

function waitForCPB() {
$('.cpb-panels-container').length ? init() : requestAnimationFrame(waitForCPB);
}
waitForCPB();

function init() {
priceConnectedToCurrencies.init();
}
});
})(jQuery);